import '@etsglobal/design-system/style.css';
import './assets/style.scss';

import { createInstance } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { initReactI18next } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';

import { i18nConfig } from '@/config/i18n/i18n.config';
import RootContainer from '@/containers/RootContainer';

import { DEFAULT_LANGUAGE, IS_DEV, IS_STAGING } from './constants';

const container = document.getElementById('root');

(async (): Promise<void> => {
  if (container) {
    const i18n = createInstance().use(LanguageDetector).use(HttpApi).use(initReactI18next);
    await i18n.init(i18nConfig);

    if ((IS_DEV || IS_STAGING) && i18n.language === 'dt') {
      await i18n.changeLanguage(DEFAULT_LANGUAGE);
    }

    ReactDOM.hydrateRoot(
      container,
      <BrowserRouter>
        <RootContainer i18n={i18n} />
      </BrowserRouter>
    );
  }
})();
